import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { MetaIndicadorRealizado, getMetaIndicadorRealizado } from '../meta-indicador-realizado';

@Component({
    selector: 'sgt-meta-indicador-realizado-perc-progress',
    templateUrl: './meta-indicador-realizado-perc-progress.component.html',
    styleUrls: ['./meta-indicador-realizado-perc-progress.component.less']
})
export class MetaIndicadorRealizadoPercProgressComponent implements OnChanges {
    /** Indicador realizado da meta */
    indicador: MetaIndicadorRealizado;

    /** Percentual realizado da meta */
    @Input() perc: number;
    /** Tamanho do progress */
    @Input() progressHeight = '7px';

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'perc') {
                this.indicador = getMetaIndicadorRealizado(this.perc);
            }
        }
    }
}
